/* AG Book Reader. StPageFlip flipbook driver.
   Config: window.AG_BOOK_CONFIG (injected by AG-Book-Reader.liquid).

   Page-image source, in priority order:
     1. manifestUrl , a JSON { page_count, aspect, preview_pages, pages:[{full,thumb}] }
                       (Phase 1 with Shopify Files: arbitrary CDN URLs).
     2. proxyBase: App Proxy path; ownership enforced server-side (Phase 2).
     3. pagesBase: pattern {base}/{book_id}/{res}/0001.webp (public bucket). */
(function () {
  "use strict";

  var CFG = window.AG_BOOK_CONFIG || {};
  var stage = document.getElementById("agb-stage");
  if (!stage) return;

  var loadingEl = document.getElementById("agb-loading");
  var controls = document.getElementById("agb-controls");
  var curEl = document.getElementById("agb-cur");
  var totalEl = document.getElementById("agb-total");

  var MANIFEST = null; // { pages:[{full,thumb}], ... } once loaded
  var RES = "std";     // default reading resolution; HD button swaps to "full"

  // these are finalised in start(), after any manifest is read
  var pageCount = parseInt(CFG.pageCount, 10) || 0;
  var preview = parseInt(CFG.previewPages, 10) || 0;
  var owned = !!CFG.owned;
  var visiblePages = 0;
  var showLock = false;

  function pad4(n) { return ("0000" + n).slice(-4); }

  // access token from the personal link (?key=) or saved in this browser
  function qp(name) { try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; } }
  var TOKEN = "";
  (function () {
    var k = qp("key");
    if (k) { TOKEN = k; try { localStorage.setItem("ag_library_token", k); } catch (e) {} }
    else { try { TOKEN = localStorage.getItem("ag_library_token") || ""; } catch (e) {} }
  })();
  function withToken(u) { return TOKEN ? u + (u.indexOf("?") >= 0 ? "&" : "?") + "token=" + encodeURIComponent(TOKEN) : u; }
  function proxyRoute(name) { return CFG.proxyBase ? CFG.proxyBase.replace(/\/[^\/]*$/, "/" + name) : "/apps/library/" + name; }

  function pageUrl(n, res) {
    res = res || "full";
    // App Proxy wins: it enforces ownership server-side via the access token.
    if (CFG.proxyBase) {
      var u = CFG.proxyBase + "?book=" + encodeURIComponent(CFG.bookId) + "&n=" + n + "&res=" + res;
      // &v=<rev> busts the immutable page cache the instant a book is re-rendered.
      if (CFG.rev) u += "&v=" + encodeURIComponent(CFG.rev);
      return withToken(u);
    }
    if (MANIFEST && MANIFEST.pages && MANIFEST.pages[n - 1]) {
      var p = MANIFEST.pages[n - 1];
      return (res === "thumb" && p.thumb) ? p.thumb : p.full;
    }
    var base = (CFG.pagesBase || "").replace(/\/+$/, "");
    return base + "/" + encodeURIComponent(CFG.bookId) + "/" + res + "/" + pad4(n) + ".webp";
  }

  function buildPages() {
    var frag = document.createDocumentFragment();
    for (var n = 1; n <= visiblePages; n++) {
      var page = document.createElement("div");
      page.className = "page";
      var img = document.createElement("img");
      img.src = pageUrl(n, RES);
      img.setAttribute("data-n", n);
      img.alt = "Page " + n;
      img.loading = n <= 4 ? "eager" : "lazy";
      if (n === 1) img.setAttribute("fetchpriority", "high");
      page.appendChild(img);
      frag.appendChild(page);
    }
    if (showLock) frag.appendChild(buildLockPage());
    else frag.appendChild(buildEndPage());
    return frag;
  }

  function buildEndPage() {
    var page = document.createElement("div");
    page.className = "page page--end";
    page.innerHTML =
      '<div class="agb-end">' +
      "  <h2>The End</h2>" +
      "  <p>Thanks for reading.</p>" +
      '  <button class="agb-btn agb-btn--ghost" id="agb-restart" type="button">↺ Back to the start</button>' +
      "</div>";
    return page;
  }

  function buildLockPage() {
    var page = document.createElement("div");
    page.className = "page page--locked";
    var remaining = pageCount - visiblePages;
    page.innerHTML =
      '<div class="agb-lock">' +
      '  <div class="agb-lock-icon">🔒</div>' +
      "  <h2>" + remaining + " more page" + (remaining === 1 ? "" : "s") + "</h2>" +
      "  <p>You've reached the end of the free preview.</p>" +
      '  <button class="agb-btn agb-btn--buy" id="agb-buy-lock" type="button">Buy access</button>' +
      '  <button class="agb-lock-restore" id="agb-restore" type="button">Already bought it? Unlock with your email</button>' +
      "</div>";
    return page;
  }

  function wireRestore() {
    var b = document.getElementById("agb-restore");
    if (!b) return;
    b.addEventListener("click", function () {
      var email = window.prompt("Enter the email you bought with. We'll unlock your books:");
      if (!email) return;
      var orig = b.textContent;
      b.textContent = "Checking…"; b.disabled = true;
      fetch(proxyRoute("claim"), {
        method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ email: email })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.token && d.books && d.books.length) {
            try { localStorage.setItem("ag_library_token", d.token); } catch (e) {}
            var u = new URL(window.location.href);
            u.searchParams.set("key", d.token);
            window.location.href = u.toString();   // reload, now unlocked
          } else {
            b.disabled = false; b.textContent = orig;
            window.alert("We couldn't find a purchase for that email. Check the address you ordered with, or buy access above.");
          }
        })
        .catch(function () { b.disabled = false; b.textContent = orig; window.alert("Sorry, something went wrong, please try again."); });
    });
  }

  function pageDims() {
    var parts = String(CFG.aspect || "1414:2000").split(":");
    var ar = (parseFloat(parts[0]) || 1414) / (parseFloat(parts[1]) || 2000);
    // Portrait (mobile) shows ONE page (usePortrait), so it should use the FULL
    // stage width, not half, which is only right for the 2-page desktop spread.
    var portrait = window.innerWidth < 768;
    var avail = stage.clientWidth || window.innerWidth || 900;
    var maxH = Math.min(window.innerHeight * (portrait ? 0.82 : 0.78), 1100);
    var maxW = portrait ? Math.min(avail, 600) : Math.min(avail / 2, 720);
    var h = maxH, w = h * ar;
    if (w > maxW) { w = maxW; h = w / ar; }
    return { w: Math.round(w), h: Math.round(h) };
  }

  function buyAccess() {
    if (!CFG.variantId) { window.location.href = CFG.productUrl; return; }
    var vid = String(CFG.variantId);
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var items = (cart && cart.items) || [], inCart = null;
        for (var i = 0; i < items.length; i++) { if (String(items[i].id) === vid) { inCart = items[i]; break; } }
        /* A PDF is a one-per-customer digital good, keep it at exactly qty 1.
           Already 1 → no-op; present but >1 (or stacked) → force back to 1;
           absent → add a single copy. */
        if (inCart && inCart.quantity === 1) return cart;
        /* Check the write actually landed. fetch() only rejects on a network error, so
           a 422 (variant not purchasable) resolved and we redirected regardless, to
           /checkout without the book, or worse, straight to checkout holding whatever
           single other line the cart happened to contain. Throwing routes to the
           .catch below, which lands the customer on /cart to see the real state. */
        if (inCart) {
          return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: vid, quantity: 1 }) })
            .then(function (r) { if (!r.ok) throw new Error("cart change failed: " + r.status); return r.json(); });
        }
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: CFG.variantId, quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error("cart add failed: " + r.status); return fetch("/cart.js", { headers: { "Accept": "application/json" } }); })
          .then(function (r) { if (!r.ok) throw new Error("cart read failed: " + r.status); return r.json(); });
      })
      .then(function (cart) {
        /* Sole item → quick-buy to checkout; other items present → cart page so
           they can review/remove first (Shopify checkout can't remove lines). */
        var onlyBook = cart && cart.items && cart.items.length === 1;
        window.location.href = onlyBook ? "/checkout" : "/cart";
      })
      .catch(function () { window.location.href = "/cart"; });
  }

  function wireBuy() {
    ["agb-buy", "agb-buy-lock"].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener("click", buyAccess);
    });
  }

  // When ownership is resolved client-side (live entitlements), reflect it in the
  // header even if the Liquid tag was stale: hide Buy, show Owned + Download.
  function syncHeader() {
    if (!owned) return;
    var buy = document.getElementById("agb-buy");
    var price = document.querySelector(".agb-price");
    if (buy) buy.style.display = "none";
    if (price) price.style.display = "none";
    var actions = document.querySelector(".agb-head-actions");
    if (actions && !document.getElementById("agb-download")) {
      var pill = document.createElement("span");
      pill.className = "agb-pill agb-pill--owned"; pill.textContent = "Owned";
      actions.insertBefore(pill, actions.firstChild);
      var dl = document.createElement("a");
      dl.id = "agb-download"; dl.className = "agb-btn agb-btn--ghost";
      dl.href = withToken(proxyRoute("download") + "?book=" + encodeURIComponent(CFG.bookId) + "&name=" + encodeURIComponent(CFG.title || ""));
      dl.setAttribute("download", (CFG.title || CFG.bookId) + ".pdf"); dl.textContent = "Download PDF";
      actions.appendChild(dl);
    }
    ensureEasyPrintButton();
  }

  // Add a "Download easy print" button next to the PDF download, but only if the
  // book has a print-friendly variant uploaded (one cheap proxy check, cached).
  var _easyChecked = false;
  function ensureEasyPrintButton() {
    if (_easyChecked) return;
    var dl = document.getElementById("agb-download");
    if (!dl) return;
    _easyChecked = true;
    fetch(withToken(proxyRoute("has-easyprint") + "?book=" + encodeURIComponent(CFG.bookId)))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.has || document.getElementById("agb-download-easy")) return;
        var ep = document.createElement("a");
        ep.id = "agb-download-easy"; ep.className = "agb-btn agb-btn--ghost";
        ep.href = withToken(proxyRoute("download") + "?book=" + encodeURIComponent(CFG.bookId) + "&variant=easyprint" + "&name=" + encodeURIComponent(CFG.title || ""));
        ep.setAttribute("download", (CFG.title || CFG.bookId) + " - Easy Print.pdf"); ep.textContent = "Download easy print";
        dl.parentNode.insertBefore(ep, dl.nextSibling);
      })
      .catch(function () { _easyChecked = false; });
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function fail(msg) { if (loadingEl) loadingEl.textContent = msg; }

  // ── page-turn sound: real mp3 if configured, else a synthesised fallback ─────
  var _actx = null, _soundBuf = null, _soundAB = null, _decoding = false, _lastSound = 0;

  // fetch the mp3 bytes early (no AudioContext needed for the download)
  if (CFG.soundUrl) {
    fetch(CFG.soundUrl).then(function (r) { return r.arrayBuffer(); })
      .then(function (ab) { _soundAB = ab; }).catch(function () { /* fallback to synth */ });
  }

  function ensureCtx() {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!_actx) _actx = new AC();
    if (_actx.state === "suspended") _actx.resume();
    return _actx;
  }

  function playSynth(ctx) {
    var dur = 0.26, sr = ctx.sampleRate, len = Math.floor(sr * dur);
    var buf = ctx.createBuffer(1, len, sr), ch = buf.getChannelData(0);
    for (var i = 0; i < len; i++) {
      var t = i / len;
      ch[i] = (Math.random() * 2 - 1) * Math.sin(Math.PI * Math.min(t * 1.8, 1)) * Math.pow(1 - t, 1.7);
    }
    var src = ctx.createBufferSource(); src.buffer = buf;
    var bp = ctx.createBiquadFilter(); bp.type = "bandpass"; bp.frequency.value = 1500; bp.Q.value = 0.5;
    var lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 2600;
    var g = ctx.createGain(); g.gain.value = 0.07;
    src.connect(bp); bp.connect(lp); lp.connect(g); g.connect(ctx.destination); src.start();
  }

  function flipSound() {
    var now = Date.now();
    if (now - _lastSound < 130) return; // de-dupe rapid state changes
    _lastSound = now;
    var ctx = ensureCtx(); if (!ctx) return;
    try {
      if (_soundBuf) {
        var s = ctx.createBufferSource(); s.buffer = _soundBuf;
        var g = ctx.createGain(); g.gain.value = (CFG.soundVolume != null ? CFG.soundVolume : 0.4);
        s.connect(g); g.connect(ctx.destination); s.start();
        return;
      }
      // decode the mp3 on first use (needs the context); play synth meanwhile
      if (_soundAB && !_decoding) {
        _decoding = true;
        try {
          ctx.decodeAudioData(_soundAB, function (b) { _soundBuf = b; }, function () {});
        } catch (e) { /* older API / decode fail -> synth */ }
        _soundAB = null;
      }
      playSynth(ctx);
    } catch (e) { /* audio unavailable, silent */ }
  }

  // ── build the flipbook once everything's resolved ───────────────────────────
  function render() {
    if (!window.St || !window.St.PageFlip) return false;

    // manifest is authoritative when present
    if (MANIFEST) {
      pageCount = MANIFEST.page_count || (MANIFEST.pages ? MANIFEST.pages.length : pageCount);
      if (MANIFEST.preview_pages != null) preview = MANIFEST.preview_pages;
      if (MANIFEST.aspect) CFG.aspect = MANIFEST.aspect;
    }
    visiblePages = owned ? pageCount : Math.min(preview, pageCount);
    showLock = !owned && visiblePages < pageCount;

    var hasSource = MANIFEST || CFG.proxyBase || CFG.pagesBase;
    if (pageCount === 0 || !hasSource) { fail("This book isn't available to read yet."); return true; }
    if (visiblePages === 0 && !showLock) { fail("No preview available, buy access to read."); return true; }

    if (loadingEl) loadingEl.remove();
    stage.appendChild(buildPages());

    var d = pageDims();
    var pf = new window.St.PageFlip(stage, {
      width: d.w, height: d.h, size: "stretch",
      minWidth: 280, maxWidth: 820, minHeight: 380, maxHeight: 1300,
      flippingTime: 750,          // smoother, slightly slower swing
      usePortrait: true,
      autoSize: true,
      drawShadow: true,
      maxShadowOpacity: 0.7,      // deeper page shadow during the turn
      showCover: true,
      showPageCorners: true,      // peel-corner hint on hover
      useMouseEvents: true,       // grab + drag the corner to peel
      clickEventForward: true,    // keep links/buttons (buy gate) clickable
      disableFlipByClick: false,
      swipeDistance: 30,
      mobileScrollSupport: false
    });
    pf.loadFromHTML(stage.querySelectorAll(".page"));

    if (totalEl) totalEl.textContent = visiblePages + 1;
    if (controls) controls.hidden = false;

    pf.on("flip", function (e) { if (curEl) curEl.textContent = e.data + 1; });
    pf.on("changeState", function (e) { if (e.data === "flipping") flipSound(); });

    var prev = document.getElementById("agb-prev");
    var next = document.getElementById("agb-next");
    if (prev) prev.addEventListener("click", function () { pf.flipPrev(); });
    if (next) next.addEventListener("click", function () { pf.flipNext(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") pf.flipPrev();
      else if (e.key === "ArrowRight") pf.flipNext();
    });

    var fs = document.getElementById("agb-fs");
    var fsOuter = stage.closest(".agb-stage-outer");
    var fsEnter = fsOuter && (fsOuter.requestFullscreen || fsOuter.webkitRequestFullscreen);
    // iPhone Safari has no element fullscreen, so the button would only throw there.
    if (fs && !fsEnter) fs.hidden = true;
    if (fs && fsEnter) fs.addEventListener("click", function () {
      if (!(document.fullscreenElement || document.webkitFullscreenElement)) {
        try {
          var p = fsEnter.call(fsOuter);
          if (p && p.catch) p.catch(function () {});
        } catch (e) { /* no-op */ }
      } else if (document.exitFullscreen) { document.exitFullscreen(); }
      else if (document.webkitExitFullscreen) { document.webkitExitFullscreen(); }
    });

    var rb = document.getElementById("agb-restart");
    if (rb) rb.addEventListener("click", function () { pf.flip(0); });

    var hd = document.getElementById("agb-hd");
    if (hd) hd.addEventListener("click", function () {
      RES = RES === "full" ? "std" : "full";
      var on = RES === "full";
      hd.classList.toggle("is-on", on);
      hd.setAttribute("aria-pressed", on ? "true" : "false");
      hd.textContent = on ? "HD ✓" : "HD";
      [].forEach.call(stage.querySelectorAll(".page img[data-n]"), function (im) {
        im.src = pageUrl(parseInt(im.getAttribute("data-n"), 10), RES);
      });
    });

    function refit() { var nd = pageDims(); pf.update({ width: nd.w, height: nd.h }); }
    window.addEventListener("resize", debounce(refit, 200));
    window.addEventListener("orientationchange", function () { setTimeout(refit, 120); });
    document.addEventListener("fullscreenchange", function () { setTimeout(refit, 80); });
    document.addEventListener("webkitfullscreenchange", function () { setTimeout(refit, 80); });

    wireBuy();
    wireRestore();
    syncHeader();
    return true;
  }

  // poll for the deferred StPageFlip global, then render
  function boot() {
    if (render()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (render() || tries > 60) clearInterval(iv);
    }, 100);
  }

  // Resolve ownership + metadata before building, then boot.
  // Ownership comes from the App Proxy /entitlements (live KV) rather than the
  // Liquid customer.tags hint, which Shopify caches and can be stale right
  // after a purchase.
  function start() {
    var jobs = [];
    if (CFG.manifestUrl) {
      jobs.push(fetch(CFG.manifestUrl, { credentials: "omit" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (m) { MANIFEST = m; })
        .catch(function () {}));
    }
    if (!owned && TOKEN && CFG.proxyBase) {
      var ck = "agent:" + TOKEN, cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(ck) || "null"); } catch (e) {}
      if (cached && cached.indexOf(CFG.bookId) !== -1) {
        owned = true; // trust a POSITIVE cache → instant unlock on repeat/return loads
      } else {
        /* No cache, OR the cache says not-owned, which can be STALE right after a
           new purchase/claim (same master token, owned list just grew). Never trust
           a negative cache: always revalidate live so a freshly-acquired book
           unlocks instead of showing "Buy access". (Access is never revoked, so a
           positive cache above is always safe to trust without a fetch.) */
        jobs.push(fetch(withToken(proxyRoute("entitlements")))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var books = (d && d.books) || [];
            try { sessionStorage.setItem(ck, JSON.stringify(books)); } catch (e) {}
            if (books.indexOf(CFG.bookId) !== -1) owned = true;
          }).catch(function () {}));
      }
    }
    if (jobs.length) Promise.all(jobs).then(boot, boot);
    else boot();
  }
  start();
})();
